import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';

export default function PageTitle({ title }) {
  useEffect(() => {
    document.title = title ? `${title} | Aullan Clinic` : 'Aullan Clinic';
  }, [title]);

  return (
    <Helmet>
      <title>{title ? `${title} | Aullan Clinic` : 'Aullan Clinic'}</title>
    </Helmet>
  );
}
